import * as z from 'zod'

export const resetPasswordSchema = z
  .object({
    email: z.email(),
    otp_code: z.string(),
    password: z.string().min(8),
    password_confirmation: z.string(),
  })
  .refine(
    ({ password, password_confirmation }) => password === password_confirmation,
    { path: ['password_confirmation'] },
  )

export type ResetPasswordDto = z.infer<typeof resetPasswordSchema>
